import React, { useState } from 'react';
import { DatePicker, Dropdown } from 'antd';
import dayjs from 'dayjs';
import { CalendarOutlined, DownOutlined } from '@ant-design/icons';
import { mondayOf, utcDay } from './statusConfig';
import s from './s.module.less';

type Props = {
    // 打开周报 drawer，参数为周一 YYYY-MM-DD
    onOpenReport: (weekStart: string) => void;
};

// Report split-button：主按钮直接开本周周报，右侧箭头展开 quick-select + 任意日期。
// 10/05 起跟 Add / Settings 一起挂在页面标题行右侧（只在 Claims tab）。
const ReportButton = ({ onOpenReport }: Props) => {
    const [menuOpen, setMenuOpen] = useState(false);

    // 任意日期归一到周一后打开周报（原型 "Any date snaps to that week's Monday."）
    const openReportFor = (d: dayjs.Dayjs) => {
        setMenuOpen(false);
        onOpenReport(mondayOf(d).format('YYYY-MM-DD'));
    };

    return (
        <Dropdown
            open={menuOpen}
            onOpenChange={setMenuOpen}
            trigger={['click']}
            dropdownRender={() => (
                <div className={`${s.filterMenu} ${s.reportMenu}`}>
                    <div className={s.reportMenuLabel}>QUICK SELECT</div>
                    {[
                        { label: 'This week', d: mondayOf(utcDay()) },
                        { label: 'Last week', d: mondayOf(utcDay().subtract(7, 'day')) },
                        { label: '2 weeks ago', d: mondayOf(utcDay().subtract(14, 'day')) },
                    ].map((q) => (
                        <button
                            key={q.label}
                            type="button"
                            className={s.reportMenuRow}
                            onClick={() => openReportFor(q.d)}
                        >
                            <span>{q.label}</span>
                            <span className={s.reportMenuDate}>{q.d.format('MMM D, YYYY')}</span>
                        </button>
                    ))}
                    <div className={s.reportMenuLabel}>CUSTOM WEEK</div>
                    <div className={s.reportMenuPicker}>
                        <DatePicker
                            suffixIcon={<CalendarOutlined />}
                            placeholder="Pick any date"
                            onChange={(d) => {
                                if (d) openReportFor(d);
                            }}
                        />
                        <p className={s.reportMenuHelper}>Any date snaps to that week&apos;s Monday.</p>
                    </div>
                </div>
            )}
        >
            <span className={s.splitBtn}>
                <button
                    type="button"
                    className={s.splitMain}
                    onClick={(e) => {
                        e.stopPropagation();
                        openReportFor(utcDay());
                    }}
                >
                    Report
                </button>
                <button type="button" className={s.splitChev}>
                    <DownOutlined className={s.filterCaret} />
                </button>
            </span>
        </Dropdown>
    );
};

export default ReportButton;
